import { LoaderService } from './../../services/loader.service';
import { MsgService, MsgSeverities } from './../../services/message.service';
import { MiddlewareService } from './../../services/middleware.service';
import { Observable } from 'rxjs';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as FloorPlanActions from '../actions/floorplan.actions'
import { switchMap, map } from 'rxjs/operators';
import { FloorPlan } from 'src/app/model/floorplan.model';
import { Injectable } from '@angular/core';

@Injectable()
export class FloorPlanEffects {
    
    constructor(
        private actions$: Actions,
        private loader: LoaderService,
        private msgService: MsgService,
        private service: MiddlewareService
    ) {}

    @Effect()
    getFloorplan$: Observable<Action> = this.actions$.pipe(
        ofType(FloorPlanActions.GET_FLOORPLAN),
        map((action: FloorPlanActions.GetFloorplan) => action.payload),
        switchMap((filename) => {
            return this.service.getFloorPlan(filename)
              .pipe(
                map((floorPlan: FloorPlan) => {
                  const testata = floorPlan.testata[0] ? floorPlan.testata[0] : floorPlan.testata;
                  testata.formato_foglio = testata['formato foglio'];
                  testata.formato_immagine = testata['formato immagine'];
                  testata.nome_file = testata['nome file'];
                  floorPlan.testata = testata;
                  floorPlan.poligono.forEach((val, idx) => {
                      val.id = 'polygon_' + idx;
                  });
                  return new FloorPlanActions.SetFloorplan(floorPlan);
                })
              )
          })
    );

    @Effect()
    sendFloorplan$: Observable<Action> = this.actions$.pipe(
        ofType(FloorPlanActions.SEND_FLOORPLAN),
        map((action: FloorPlanActions.SendFloorplan) => action.payload),
        switchMap((plan: FloorPlan) => {
            this.loader.show();
            return this.service.putFloorPlan(plan)
              .pipe(
                map((resp: any) => {
                  this.loader.hide();
                  const filepath = resp.filePath;
                  this.msgService.showMsg(MsgSeverities.SUCCESS, 'Info', `File inviato correttamente nel path: ${filepath}`);
                  return new FloorPlanActions.SetFloorplan(plan);
                })
              )
          })
    );
}